import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Toasted from 'vue-toasted';
import VueProgressBar from 'vue-progressbar';
import '@app2/core/register-global';
import '@app2/core/register-userpilot';
import '@app2/core/register-boostrap-vue';
// import '@app2/core/register-logrocket';
import moment from 'moment';
import '@app2/modules/Library/Builder/playlist.app';

import UserPilotManager from '@app2/utils/UserPilotManager';

import App from '@app2/App.vue';
import router from '@app2/router/';
import store from '@app2/store';

import axios from '@app2/api/axios';
window.axios = axios;
window.moment = moment;

import '@app2/utils/filters';
import '@app2/utils/directives';
import VueMeta from 'vue-meta';

import eventBus from '@app2/core/eventBus';
import File from '@app2/models/File';


// import * as Sentry from '@sentry/vue'
//
// Sentry.init({
//   Vue: Vue,
//   dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
//   environment: process.env.MIX_SENTRY_ENVIRONMENT,
// })

Vue.use(VueMeta);
Vue.use(Vuelidate);
Vue.use(Toasted, {
  duration: 4000,
  icon: 'icon',
  theme: 'bubble',
  position: 'bottom-center',
  className: 'searchie-toast',
  containerClass: 'searchie-toast-cont',
  iconPack: 'custom-class',
  action: {
    text: '',
    class: 'close',
    onClick(e, toastObject) {
      toastObject.goAway(0);
    },
  },
});
Vue.use(VueProgressBar, {
  color: '#f8d133',
  failedColor: '#ff0909',
  height: '3px',
});

window.store = store;

const vueConfig = {
  el: '#app',
  store,
  router,
  render: h => h(App),
};

if (process.env.NODE_ENV === 'production') {
  vueConfig.watch = {
    "$route": () => {
      if (window.Appcues)
        window.Appcues.page()
    }
  }
}

// declare global Vue before vue-bootstrap does, to prevent it's own Vue declaration that throws an Error
window.Vue = Vue
window.Bus = new Vue()
require('@app-spark/vue-bootstrap');

const userPilot = new UserPilotManager();
userPilot.mount();

Vue.prototype.$assetUrl = process.env.MIX_ASSET_URL || '';

/**
 * Global listener for featured media auto-save
 * This runs at app level and persists even when components are destroyed
 */
eventBus.$on('file-upload-complete', async ({ uploadId, fileHash, fileName, fileType }) => {
  // Check if any document is waiting for this upload
  const pendingRelationship = store.getters['pendingFeaturedMedia/GET_BY_UPLOAD_ID'](uploadId);
  
  if (pendingRelationship) {
    const { documentHash } = pendingRelationship;
    
    try {
      // Update status to processing
      store.commit('pendingFeaturedMedia/UPDATE_STATUS', {
        documentHash,
        status: 'processing'
      });
      
      // Auto-save the featured media relationship to backend
      // Use axios directly to save only featured_file_hash without affecting VuexORM change tracking
      const document = File.find(documentHash);
      
      // Save only the featured_file_hash to backend using axios
      await axios.put(`/api/internal/v2/files/${documentHash}`, {
        title: document?.title || 'Untitled',
        folder_id: document?.folder_id,
        featured_file_hash: fileHash
      });
      
      // Update the File model in the store
      File.update({
        where: documentHash,
        data: {
          featured_file_hash: fileHash,
          featured_media: File.find(fileHash)
        }
      });

      // Update only the featured_file_hash in the initial state
      // This prevents featured media from triggering save/discard buttons
      // while keeping title/description changes unsaved
      const updatedDocument = File.find(documentHash);
      if (updatedDocument?.setPropertyToInitial) {
        updatedDocument.setPropertyToInitial('featured_file_hash', fileHash);
      }
      
      // Clean up pending relationship
      store.commit('pendingFeaturedMedia/REMOVE', documentHash);
      
      // Show success notification
      Vue.toasted.show(`Featured media "${fileName}" linked successfully.`, {
        type: 'success',
        icon: 'icon'
      });
      
      console.log(`[Auto-Save] Featured media ${fileHash} linked to document ${documentHash}`);
    } catch (error) {
      console.error('[Auto-Save] Failed to link featured media:', error);
      
      // Store error state
      store.commit('pendingFeaturedMedia/SET_ERROR', {
        documentHash,
        error: error.message || 'Failed to link featured media'
      });
      
      // Show error notification
      Vue.toasted.show('Failed to link featured media automatically. Please try again.', {
        type: 'error',
        icon: 'icon'
      });
    }
  }
});

export default new Vue(vueConfig);
